<template>
  <div class="post-area-root">
    <SPreloader />
    <SSubHeader :pageName="'Item activity'" :backButton="true" />
    <div class="published-container">
      <PublishedItems />
    </div>
    <Footer/>
    <Modal
      buttonName="OK"
      id="welcome-activity"
      title="Item activity"
      :materialButton="true"
      @button="closeModal('welcome-activity')"
      @close="closeModal('welcome-activity')"
      ref="welcomeActivity"
      data-cy="welcomeActivity"
    >
      <p class="h5 text-center">
        All of your item activities are listed on this page. <br />
        If you want to search for a specific item activity, <br />
        use the page filter
      </p>
      <DontShowAgainModal @option="saveOption" />
    </Modal>
    <a class="back-to-top arrow-top" href="#" v-if="pageBottom">
      <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
  </div>
</template>

<script>
import PublishedItems from "@/components/molecules/PublishedItems";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ChatHelperVue from "@/mixins/ChatHelper.vue";
import Modal from "@/components/atoms/Modal";
import SPreloader from "@/components/organisms/SPreloader.vue";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import DontShowAgainModal from "@/material-components/atoms/DontShowAgainModal.vue";
import modalType from "@/enum/modal-type";
import Footer from "@/templates/Footer";

export default {
  name: "MyPostArea",
  mixins: [ItemHelperVue, UserHelperVue, ChatHelperVue, PointsHelperVue],
  components: {
    PublishedItems,
    Modal,
    SPreloader,
    SSubHeader,
    DontShowAgainModal,
    Footer,
  },
  data() {
    return {
      dontShowModalAgain: false,
    };
  },
  methods: {
    saveOption(value) {
      this.dontShowModalAgain = value;
    },
    async saveOptionDontShowAgain() {
      if (this.dontShowModalAgain === true) {
        const userModal = {
          modal_Type: modalType.ACTIVITY_PAGE,
          user_Id: this.loggedUser.id,
        };
        await this.saveDontShowAgain(userModal);
      }
    },
    async getDontShowOption() {
      const userModal = {
        modalType: modalType.ACTIVITY_PAGE,
        userId: this.loggedUser.id,
      };
      let response = await this.getDontShowModal(userModal);
      this.dontShowModalAgain = response.dontShowModal;
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal("hide");
      setTimeout(() => {
        if (modalId === "welcome-activity") {
          this.closeWelcomeModal();
        }
      }, 501);
    },
    async showWelcomeModal() {
      await this.getDontShowOption();
      if (this.dontShowModalAgain === false) {
        $("#welcome-activity").modal("show");
      }
    },
    async closeWelcomeModal() {
      if (this.dontShowModalAgain === true) {
        await this.saveOptionDontShowAgain();
      }
      this.$refs.welcomeActivity.closeModal();
    },
  },
  created() {
    this.fetchItemRequestMade();
    this.fetchItemRequestReceived();
    this.fetchUserInventory(localStorage.getItem("user_id"));
    document.addEventListener("click", (event) => {
      if (
        !$(event.target).closest(".modal-content").length &&
        $("#accept").is(":visible")
      ) {
        this.closeModal();
      }
    });
  },
  mounted() {
    setTimeout(() => {
      this.showWelcomeModal();
    }, 1001);
  },
};
</script>

<style scoped>
.post-area-root {
  width: 100%;
  margin-top: 108px;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.published-container {
  width: 100%;
  height: 100%
}
</style>
